import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as WarningIcon } from '../../assets/svg/warning_outlined.svg';
import useDictionary from '../../hooks/useDictionary';
import Dictionary from '../../utils/dictionary';
import useStyles from './useStyles';

const FareAlert = ({ isRefundable, hasPenalty }) => {
  const classes = useStyles();
  const getDictionary = useDictionary(Dictionary);

  if (isRefundable && !hasPenalty) return null;

  return (
    <div className={classes.fareAlert} role="alert">
      <WarningIcon className={classes.icon} />
      <div className={classes.content}>
        {!isRefundable && (
          <>
            <p className={classes.title}>
              {getDictionary(Dictionary.airFareAlertNonRefundableTitle.key)}
            </p>
            <p className={classes.text}>
              {getDictionary(Dictionary.airFareAlertNonRefundableDescription.key)}
            </p>
          </>
        )}
        {hasPenalty && (
          <p className={classes.text}>
            {getDictionary(Dictionary.airFareAlertPenaltyDescription.key)}
          </p>
        )}
      </div>
    </div>
  );
};

FareAlert.propTypes = {
  isRefundable: PropTypes.bool,
  hasPenalty: PropTypes.bool,
};

FareAlert.defaultProps = {
  isRefundable: true,
  hasPenalty: false,
};

export default FareAlert;
